export default {
  host: import.meta.env.VITE_PRESENTATION_APP_URL
}
